import Http from '@/api/http.js'
import ClientFinancial from './clients/financial'
import lastPaymentMethods from './clients/lastPaymentMethods'

export default {
  ...ClientFinancial,
  ...lastPaymentMethods,

  exportCsv(filter){
    return Http.get(`/clients.csv`, {params:{ filter: filter}});
  },
  exportClientsXlsx(params = {}){
    return Http.get('/clients.xlsx',{
      params: {
        ...params
      }
    })
  },
  exportClientsPDF( params = {}){
    return Http.get('/clients.pdf',{
      params: {
        ...params
      }
    });
  },
  
  index(filter){
    return Http.get(`/clients.json`, {params:{ ...filter}});
  },
  search(params){
    return Http.get(`/clients/search`, {params:{ ...params}});
  },
  indexByDocument(document){
    return Http.get(`/clients/by_document/${document}`);
  },

  employeeClients(id){
    return Http.get(`/clients/list_clients/${id}`);
  },

  indexBillingClients(client_id){
    return Http.get(`/clients/${client_id}/other_clients`);
  },
  showBillingClient(client_id, doc_id){
    return Http.get(`/clients/${client_id}/other_clients/${doc_id}`);
  },
  createBillingClient(client_id, billing_client){
    const {name, cpf_cnpj, zip_code, number, complement, city, state, district, street} = billing_client
    let obj = {name, cpf_cnpj: cpf_cnpj.toString().replace(/[\W]/g, ""), zip_code, number, complement, city, state, district, street}

    return Http.post(`/clients/${client_id}/other_clients`, {other_client: { ...obj} });
  },
  updateBillingClient(client_id, billing_client){
    const {name, cpf_cnpj, zip_code, number, complement, city, state, district, street} = billing_client
    let obj = {name, cpf_cnpj: cpf_cnpj.toString().replace(/[\W]/g, ""), zip_code, number, complement, city, state, district, street}

    return Http.put(`/clients/${client_id}/other_clients/${cpf_cnpj}`, {other_client: { ...obj} });
  },

  create(client){
    return Http.post('/clients', {
      client
    });
  },
  
  basicUpdate(client){
    return Http.put(`/clients/${client.id}`, { client })
  },
  updateCredit(updateClient, id) {
    return Http.put(`/clients/${id}`, {
      client: {
        id:             id,
        'client_credit_attributes':       updateClient.client_credit_attributes, //precisava ser vetor!
        status_id :     updateClient.status_id,
      }, 
      forced: updateClient.forced
    });
  },

  updateEconomicGroup(economic_group_id, id) {
    return Http.put(`/clients/${id}`, {
      client: {
        id: id,
        economic_group_id,
      }
    });
  },

  updateAddress(updateClient, id) {
    return Http.put(`/clients/${id}`, {
      client: {
        id: id,
        'addresses_attributes':   [updateClient.addresses_attributes],
        'shipping_addresses_attributes':   [updateClient.addresses_attributes, ...updateClient.shipping_addresses_attributes],
      }
    });
  },

  updateInfo(updateClient, id) {
    return Http.put(`/clients/${id}`, {
      client: {
        id: id,
        fantasyName:    updateClient.fantasyName,
        corporateName:  updateClient.corporateName,
        CNPJ:           updateClient.CNPJ && updateClient.CNPJ.toString().replace(/[\W]/g, "") || '',
        CPF:            updateClient.CPF && updateClient.CPF.toString().replace(/[\W]/g, "") || '',
        name:           updateClient.name,
        status_id :     updateClient.status_id,
        category :      updateClient.category,
        fixed_company_in_pix :     updateClient.fixed_company_in_pix,

        'document_attributes':   updateClient.document_attributes,
      }
    });
  },

  updateSeller(updateClient, id) {
    return Http.put(`/clients/${id}`, {
      client: {
        id: id,
        'client_sellers_attributes':  updateClient.client_sellers_attributes,
        // employee_id: updateClient.employee_id,
      }
    });
  },

  updateAccount(updateClient, id) {
    return Http.put(`/clients/${id}`, {
      client: {
        id: id,
        'accounts_attributes':  updateClient.accounts_attributes,
      }
    });
  },

  updateContact(updateClient, id) {
    return Http.put(`/clients/${id}`, {
      client: {
        id: id,
        'contacts_attributes':  updateClient.contacts_attributes,
      }
    });
  },

  show(params){
    let {id, ...rest} = params
    return Http.get(`/clients/${id}`, {params: {...rest}});
  },
  check_credit(id){
    return Http.get(`/clients/${id}/check_client_credit`);
  },
  updateWithFormData(client){
    return Http.put(`/clients/${client.get('client[id]')}`, client);
  },

  showClientLastOrder(filter = {}) {
    return Http.get(`/client_last_orders`, {params: {...filter}});
  },
}
